import React from "react";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormLogin from "../../components/FormLogin";
import { useAuth } from "../../context/AuthContext";

const Link = styled.a`
  color: blue;
  cursor: pointer;
  :hover {
    text-decoration: underline;
    color: blue;
  }
`;

const Logins = ({ history, location }) => {
  const { getFirstMenuPath } = useAuth();
  const onLogin = async () => history.push(location.state && location.state.from ? location.state.from : await getFirstMenuPath());

  const handlePersuacion = () => {
    // acá se podria incluir la persuacion del login para mfa
    history.push({
      pathname: `/profile`,
    });
  };

  return (
    <>
      <Helmet>
        <title>PIN - Login</title>
      </Helmet>
      <FormLogin onLogin={onLogin} handlePersuacion={handlePersuacion} />
      <div className="d-flex justify-content-center align-items-center">
        <FontAwesomeIcon icon="fa-solid fa-user-gear" color="gray" className="mr-2 mb-1 text-center" size="1x" />
        <p className="text-center mb-0" style={{ fontSize: "12px", color: "gray" }}>
          Si tenes problemas para iniciar sesión, hacé{" "}
          <Link target="_blank" href=" https://adecco.service-now.com/">
            click acá
          </Link>
        </p>
      </div>
    </>
  );
};

export default withRouter(Logins);
